/*------------------------------------*\
    skrollr
\*------------------------------------*/

module.exports = function(){

    // $(window).load necessary to load script after Angular
    // does its stuff on Get Fitted, apparently

    $(window).load(function() {

        if ($(window).width() > 900) {
            var s = skrollr.init({
                forceHeight: false
            });
        }

    });


}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/blocks/skrollr.js